import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Programacion } from '../models/programacion';
@Injectable({
  providedIn: 'root'
})
export class ProgramacionService {

  constructor(private http: HttpClient) { }

  private programaciones: Programacion[];
  private programaciones$ = new Subject<Programacion[]>();

  private programacion: Programacion;
  private programacion$ = new Subject<Programacion>();

  change(val) {
    this.programaciones = val;
    this.programaciones$.next(this.programaciones);
  }
  get$(): Observable<Programacion[]> {
    return this.programaciones$.asObservable();
  }

  changeOne(val) {
    this.programacion = val;
    this.programacion$.next(this.programacion);
  }
  getOne$(): Observable<Programacion> {
    return this.programacion$.asObservable();
  }

  getAll(): Observable<Programacion[]> {
    return this.http.get(environment.apiUrl + 'programacion')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Programacion[]> {

    return this.http.post(environment.apiUrl + 'programacion/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }


  get(id) {
    return this.http.get(environment.apiUrl + 'programacion/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'programacion', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'programacion';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'programacion/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
}
